import { useAuthContext } from "@/features/auth/contexts/auth-context";
import { Permiso } from "@/shared/types/permiso";
import ErrorPage from "@/pages/error";
import { PropsWithChildren } from "react";
import { Outlet } from "react-router";

export interface RequirePermisosProps extends PropsWithChildren{
    permisos:Permiso[]
}

export default function RequirePermisos({
    children,
    permisos
}:RequirePermisosProps){
    if(!useAuthContext().hasPermisos(...permisos)) {
        return <ErrorPage.Content status={403} title={"No autorizado"} message={"No tienes los permisos necesarios para ver este contenido."} />
    }

    return children?children:<Outlet />;
}